import Base64 from "@/common/utils/base64"
import { decodeBTLink } from './bt'

export const noop = (..._args: any[]): any => undefined

export const delay = (time: number) => {
    return new Promise((resolve) => {
        setTimeout(resolve, time)
    })
}

export function numberToStringWithinObject(obj: object): object {
    return Object.keys(obj).reduce<object>((result, k) => {
        // @ts-ignore
        result[k] = typeof obj[k] === 'number' ? String(obj[k]) : obj[k]
        return result
    }, {})
}

export function json2querys(data: any) {
    const params = Object.keys(data).map((k) => {
        const v = data[k]
        if (typeof v === 'object') {
            if (v) return `${k}=${JSON.stringify(v)}`
            // v is null
            return k
        } else {
            if (v) return `${k}=${v}`
            // eslint-disable-next-line no-self-compare
            if (v !== v) return `${k}=${v}`
            if (v === 0) return `${k}=${v}`
            if (v === false) return `${k}=${v}`
            return k
        }
    })
    return params.join('&')
}

export function querys2json(url: string): { [propName: string]: string } {
    // const queryStr = decodeURIComponent(url)?.replace(/(.*\?)/g, '')
    const queryStr = url?.replace(/([^?]*\?)/, '')
    const ary = queryStr.split('&')
    return ary.reduce((prev, next) => {
        const [key, value] = next.split('=')
        // @ts-ignore
        prev[key] = decodeURIComponent(value)
        return prev
    }, {})
}

/** 对数字num保留小数点后e位（直接截取） */
export function interceptDigital(num: number, e: number) {
    if (e === 0) return num | 0
    const base = 10 ** e
    const result = ((num * base) | 0) / base
    return result
}

/**
 * 确保小数点位数
 * @param num 需要转换的数字
 * @param decimal 需要精确的小数点后位数
 * @example
 * (num = 9.1, decimal = 1) => '9.1'
 * (num = 9, decimal) = 2 => '9.00'
 */
function makesureDecimal(num: number, decimal: number) {
    if (decimal <= 0) return '' + num
    const [n, d = ''] = String(num).split('.')
    return `${n}.${d.padEnd(decimal, '0')}`
}

/**
 * 将内存字节数转化位可读的字符串形式
 * @param memory 字节数
 * @param decimal 精度值，1代表保留小数点后1位数。默认为1
 * @returns 可读的存储值
 */
export function formatMemory(memory: number = 0, decimal = 1) {
    const Unit = 1024
    const KB = Unit
    const MB = Unit * KB
    const GB = Unit * MB
    const TB = Unit * GB
    if (memory >= 1 * TB) {
        const shortMem = interceptDigital(memory / TB, decimal)
        return `${makesureDecimal(shortMem, decimal)}TB`
    }
    if (memory >= 1 * GB) {
        const shortMem = interceptDigital(memory / GB, decimal)
        return `${makesureDecimal(shortMem, decimal)}GB`
    }
    if (memory >= 1 * MB) {
        const shortMem = interceptDigital(memory / MB, decimal)
        return `${makesureDecimal(shortMem, decimal)}MB`
    }
    if (memory >= 1 * KB) {
        const shortMem = interceptDigital(memory / KB, decimal)
        return `${makesureDecimal(shortMem, decimal)}KB`
    }
    if (memory < 0) return '0B'
    return `${memory}B`
}

export function numberLimit(n: number, limit = 99) {
    return n <= limit ? `${n}` : `${limit}+`
}

export function jsonPare(stringify: unknown): ({ [key: string]: any }) {
    if (!stringify) return {}
    if (typeof stringify === 'object') return stringify
    if (typeof stringify === 'string') {
        try {
            return JSON.parse(stringify)
        } catch (err) {
            console.log(err)
            return {}
        }
    } else {
        return {}
    }
}

/** 用户当出现错误时，获取错误对象的消息提示 */
export function getErrorMessage(err: any) {
    if (typeof err === 'string') return err
    if (err instanceof Error) return err.message
    if (err && typeof err === 'object' && err.message) return err.message
    return String(err)
}

export const isXlCloudShareLink = (link: string) => /(https?:\/\/pan\.xunlei\.com\/s\/([0-9a-zA-Z_-]+)(\?[^#\s]*)?(#\S*)?)(\s*提取密?码\W*(\w+))?/.test(link)
export const isXlShareLink = (link: string) => /【迅雷口令#X(\w+)#】(.*提取密?码\W*(\w+))?/.test(link)
export const isThunderLink = (link: string) => /thunder:\/\/\S*/i.test(link)
export const isMagnetTypeBTLink = (link: string) => {
    const magnetReg = /magnet:\?xt=urn:btih:[0-9a-zA-Z]{30,}.*/
    const isMagnet = magnetReg.test(link)
    if (isMagnet) return true
    if (!isThunderLink(link)) return false
    const content = decodeThunderScheme(link.split(/\s/).slice(0, 1).join(''))
    return magnetReg.test(content)
}

export const isOtherTypeBTLink = (link: string) => /(thunder|http|https|ed2k|ftp):\/\/\S*/.test(link)
export const isBTLink = (link: string) => isMagnetTypeBTLink(link) || isOtherTypeBTLink(link)
export const isTorrent = (url: string) => /\.torrent$/i.test(url)
export const isYunPanSharedLink = (link: string) => /(https|http):\/\/pan\.xunlei\.com\/s\/([0-9a-zA-Z_-]{1,})\?*(.*=[0-9a-zA-Z]+)*#{0,}/g.test(link)
export const isThunderPwdLink = (link: string) => /迅雷口令#[0-9a-zA-Z_]{8,12}#.*/.test(link)

export function extractThunderLink(link: string) {
    if (/(thunder:\/\/\S*)/i.test(link)) return RegExp.$1
    return ''
}

export function extractMagnetLink(link: string) {
    if (/(magnet:\?xt=urn:btih:[0-9a-zA-Z]{30,}[^\s]+)/.test(link)) return RegExp.$1
    return ''
}

export function extractEd2kLink(link: string) {
    if (/(ed2k:\/\/\|file\|([^|]+)\|(\d+)\|([a-fA-F\d]{32})\|)/.test(link)) return RegExp.$1
    return ''
}

export function extractOtherLink(link: string) {
    if (/(ed2k:\/\/)/.test(link)) return extractEd2kLink(link)
    if (/((http|https|ftp):\/\/\S*)/.test(link)) return RegExp.$1
    return ''
}

export function extractXlShareLinkInfo(link: string) {
    if (!isXlShareLink(link)) return { id: '', password: '' }
    return {
        id: RegExp.$1,
        password: RegExp.$3,
    }
}

export function extractXlCloudShareLinkInfo(link: string) {
    if (!isXlCloudShareLink(link)) return { id: '', link, password: '' }
    const url = RegExp.$1
    const shareId = RegExp.$2
    const search = RegExp.$3
    const password = RegExp.$6
    const querys = querys2json(search)
    const info = {
        id: shareId,
        link: /pwd=/.test(url) ? url : url + `?pwd=${(password || querys.pwd)}#`,
        password: password || querys.pwd,
    }

    return info
}

const removeRepetBtLink = (links: string[]): string[] => {
    const map: { [link: string]: boolean } = {}
    // @ts-ignore
    return links.reduce((result: string[], link: string) => {
        if (!map[link]) {
            result.push(link)
            map[link] = true
        }
        return result
    }, [])
}

export const matchBatchBtLink = (links: string, removeRepet?: boolean): [string[], string[]] => {
    const magnets = links.match(/magnet:\?xt=urn:btih:[0-9a-zA-Z]{30,}[^(magnet|&)|0-9a-zA-Z]*/g) || ([] as string[])
    const _links = links.replace(/(magnet:\?xt=urn:btih:[0-9a-zA-Z]{30,})(\S*)/gi, '$1')
    const ed2kLinks = _links.match(/(ed2k:\/\/\|file\|([^|]+)\|(\d+)\|([a-fA-F\d]{32})\|)/g) || []
    const downloadUrls = _links.match(/(http|https|ftp):\/\/\S*/g) || []
    const ThunderLinks = _links.match(/thunder:\/\/\S*/g) || []
    const otherLinks = Array.from(ThunderLinks).reduce((links: string[], url: string) => {
        // 解开thunder协议链接，将内容进行再次匹配后归类
        if (/^thunder:\/\//i.test(url)) {
            const text = decodeThunderScheme(url)
            const [mlinks, urls] = matchBatchBtLink(text)
            // thunder协议内容中含有magnet磁力链接，将其归类到magnets数组中
            if (mlinks.length) {
                magnets.push(...mlinks)
            }
            links.push(...urls)
            return links
        }
        links.push(url)
        return links
    }, [] as string[]).concat(ed2kLinks, downloadUrls)
    const cn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|\s/g
    const _magnets = magnets.map(item => item.replace(cn, '')) as string[]
    return [
        removeRepet ? removeRepetBtLink(_magnets) : _magnets,
        removeRepet ? removeRepetBtLink(otherLinks) : otherLinks
    ]
}

/** 解析thunder协议链接 */
export function decodeThunderScheme(thunderLink: string) {
    if (!/^thunder:\/\//i.test(thunderLink)) return thunderLink
    const link = thunderLink.replace(/^thunder:\/\//i, '')
    const content = Base64.decode(link).replace(/^AA(.+)ZZ$/, '$1')
    return decodeBTLink(decodeURIComponent(content))
}

export function copyToClipboard(text: string = '') {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
        return //codes below wont be executed
    }
    const textArea = document.createElement("textarea")
    textArea.value = text

    document.body.appendChild(textArea)

    textArea.focus()
    textArea.select()

    document.execCommand('copy')

    document.body.removeChild(textArea)
}

export function detectIsIPad() {
    return navigator.userAgent.toLowerCase().match(/iPad/i)
}
